import { message } from "antd";
import axios from "../../../axiosInstance";
import {
  APPLY_ADMISSION_REQUEST,
  APPLY_ADMISSION_SUCCESS,
  APPLY_ADMISSION_FAIL,
  GET_ALL_ADMISSIONS_REQUEST,
  GET_ALL_ADMISSIONS_SUCCESS,
  GET_ALL_ADMISSIONS_FAIL,
  UPDATE_ADMISSION_STATUS_REQUEST,
  UPDATE_ADMISSION_STATUS_SUCCESS,
  UPDATE_ADMISSION_STATUS_FAIL,
  UPDATE_ADMISSION_DETAILS_REQUEST,
  UPDATE_ADMISSION_DETAILS_SUCCESS,
  UPDATE_ADMISSION_DETAILS_FAIL,
  DELETE_ADMISSION_REQUEST,
  DELETE_ADMISSION_SUCCESS,
  DELETE_ADMISSION_FAIL,
  CLEAR_ERRORS
} from "../../constants/admin/admissionConstants";

// Student Apply for Admission
export const applyForAdmission = (admissionData) => async (dispatch) => {
  try {
    dispatch({ type: APPLY_ADMISSION_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.post("/api/v1/admission/apply", admissionData, config);

    dispatch({ type: APPLY_ADMISSION_SUCCESS, payload: data });

    message.success(data.message || "Admission applied successfully!");
  } catch (error) {
    dispatch({
      type: APPLY_ADMISSION_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(error.response?.data?.message || "Something went wrong");
  }
};

// Get All Admissions (Admin)
export const getAllAdmissions = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_ADMISSIONS_REQUEST });

    const { data } = await axios.get("/api/v1/admission-form");
    dispatch({ type: GET_ALL_ADMISSIONS_SUCCESS, payload: data.admission });
  } catch (error) {
    dispatch({
      type: GET_ALL_ADMISSIONS_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(error.response?.data?.message || "Failed to fetch admissions");
  }
};

// Update Admission Status (Admin)
export const updateAdmissionStatus = (id, paymentStatus) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ADMISSION_STATUS_REQUEST });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await axios.post(`/api/v1/admission-form/${id}/verify-payment`, {paymentStatus }, config);

    dispatch({ type: UPDATE_ADMISSION_STATUS_SUCCESS, payload: data });

    message.success(data.message || "Admission status updated successfully!");
  } catch (error) {
    dispatch({
      type: UPDATE_ADMISSION_STATUS_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(error.response?.data?.message || "Failed to update admission status");
  }
};

// Update Admission Details (Admin)
export const updateAdmissionDetails = (id, updateData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ADMISSION_DETAILS_REQUEST });

    const config = { 
      headers: { 
        "Content-Type": "application/json",
      } 
    };

    // Format dates before sending
    const formattedData = { ...updateData };
    
    // Convert date strings to ISO format
    if (formattedData.birthDate && typeof formattedData.birthDate === 'string') {
      try {
        formattedData.birthDate = new Date(formattedData.birthDate).toISOString();
      } catch (error) {
        console.error("Error formatting birthDate:", error);
      }
    }
    
    if (formattedData.paymentDate && typeof formattedData.paymentDate === 'string') {
      try {
        formattedData.paymentDate = new Date(formattedData.paymentDate).toISOString();
      } catch (error) {
        console.error("Error formatting paymentDate:", error);
      }
    }

    const { data } = await axios.put(
    `/api/v1/admission-form/${id}`, 
      { 
        updateData: formattedData 
      }, 
      config
    );

    dispatch({ 
      type: UPDATE_ADMISSION_DETAILS_SUCCESS, 
      payload: data 
    });

    message.success(data.message || "Admission details updated successfully!");
    
    return data;
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Something went wrong";
    
    dispatch({
      type: UPDATE_ADMISSION_DETAILS_FAIL,
      payload: errorMessage,
    });
    
    message.error(errorMessage);
    
    throw new Error(errorMessage);
  }
};

// Delete Admission (Admin)
export const deleteAdmission = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ADMISSION_REQUEST });

    const { data } = await axios.delete(`/api/v1/admission-form/${id}`);

    dispatch({ type: DELETE_ADMISSION_SUCCESS, payload: data });

    message.success(data.message || "Admission deleted successfully!");
  } catch (error) {
    dispatch({
      type: DELETE_ADMISSION_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(error.response?.data?.message || "Failed to delete admission");
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};